import React from 'react';
import './sec1-p2.css'
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';
import Search from '../components/common/search';
import pic37 from '../assets/pic37.png'
import pic38 from '../assets/pic38.png'
import Filter from '../components/common/filter';
import pic39 from '../assets/pic39.png'
import pic40 from '../assets/pic40.png'
import pic41 from '../assets/pic41.png'

const Sec1p2 = ({ loading, setSelectedCategory, searchTerm, setSearchTerm }) => {



  const secRef = useRef(null);


useEffect(() => {
  if (loading) return;

  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, [loading]);







    const [headers, setheaders]= useState([]);

useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
console.log(res.data);
console.log(res.data[0]?.title_ar);
setheaders(res.data);
}
getheaders();
}, []);



    return ( 
        <section className='sec1-containerp2'  ref={secRef}>
             <article className='sec1-sub-containerp2'>
                                <h1 className='header-herop2'>{headers?.[8]?.header}</h1>
                                <form className='button-sec1-p2'>
                                    <Search placeholder='Search for Exhibitors...' icon={pic37}  onChange={(e) => setSearchTerm(e.target.value)}/>
                                    <Filter placeholder='Filter' icon={pic38} icon2={pic39}   onSelect={setSelectedCategory}   />
                                </form>
            </article>



            <img className='img-dec-sec1-p2-righht' src={pic40} alt='workspace-img'></img>
            <img className='img-dec-sec1-p2-leftt' src={pic41} alt='workspace-img'></img>





        </section>
     );
}
 
export default Sec1p2;